import { Link, NavLink } from "react-router-dom";
import { LOGO } from "../lib/api";
import { useAuth } from "../lib/AuthContext";
import { useI18n } from "../lib/LanguageContext";
import { useCart } from "../lib/CartContext";
import { Button } from "./ui/button";
import { LogOut, Menu, X, ShoppingCart } from "lucide-react";
import { useState } from "react";
import LanguageSwitcher from "./LanguageSwitcher";

export default function NavBar() {
  const { user, logout } = useAuth();
  const { t } = useI18n();
  const { count } = useCart();
  const [open, setOpen] = useState(false);
  const links = [
    { to: "/", label: t("nav.home") },
    { to: "/tentang", label: t("nav.about") },
    { to: "/produk", label: t("nav.products") },
    { to: "/edukasi", label: t("nav.education") },
    { to: "/nuna", label: t("nav.nuna") },
    { to: "/harga", label: t("nav.pricing") },
  ];
  return (
    <header className="sticky top-0 z-50 glass border-b border-teal/10" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link"><img src={LOGO} alt="GIDZA INSTITUTE" className="gidza-logo"/></Link>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-${l.to.replace('/','') || 'home'}`}
              className={({ isActive }) => `link-underline text-sm ${isActive ? "text-teal font-semibold" : "text-foreground/80 hover:text-teal"}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <LanguageSwitcher/>
          {user?.is_admin && <Link to="/admin/vouchers" className="hidden md:inline-flex items-center gap-1 text-xs px-2 py-1 bg-amber-50 border border-amber-200 text-amber-800 rounded font-semibold uppercase tracking-widest" data-testid="admin-link">Admin</Link>}
          <Link to="/keranjang" className="relative p-2 hover:text-teal" data-testid="cart-btn">
            <ShoppingCart className="w-5 h-5"/>
            {count > 0 && <span className="absolute -top-0.5 -right-0.5 bg-teal text-white text-[10px] font-bold rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center">{count}</span>}
          </Link>
          {user ? (
            <>
              <Link to="/nuna" className="hidden md:block text-sm text-muted-foreground ml-1">{t("nav.greeting")}, <span className="text-teal font-semibold">{user.full_name?.split(" ")[0]}</span></Link>
              <Button onClick={logout} variant="outline" size="sm" className="rounded-full ml-1" data-testid="logout-btn"><LogOut className="w-4 h-4 mr-1"/> {t("nav.logout")}</Button>
            </>
          ) : (
            <>
              <Link to="/masuk" className="hidden md:inline-block text-sm font-medium hover:text-teal ml-1" data-testid="login-link">{t("nav.login")}</Link>
              <Link to="/daftar"><Button className="rounded-full bg-teal hover:bg-teal/90 text-white" data-testid="register-btn">{t("nav.register")}</Button></Link>
            </>
          )}
          <button className="lg:hidden ml-1" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">{open ? <X/> : <Menu/>}</button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-teal/10 bg-white">
          <div className="flex flex-col px-6 py-4 gap-3">
            {links.map((l) => <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="py-1">{l.label}</NavLink>)}
            {!user && <Link to="/masuk" onClick={() => setOpen(false)} className="py-1">{t("nav.login")}</Link>}
          </div>
        </div>
      )}
    </header>
  );
}
